import { useTranslation } from 'react-i18next';
import { Chip } from '@material-ui/core';
// eslint-disable-next-line import/no-unresolved
import { useOrdinalSuffix } from '@commonClient2/hooks';
import { UkgDateFormat } from '../../Enums';
import DateFormatService from '../../services/DateFormatService';

import './EmployeeInfoContent.scss';
import { getProfileStatusLabel } from '../../Enums/Helpers/LabellingHelper';
import { getProfileStatusColor } from '../../Enums/Helpers/StylingHelper';

/**
 * @param {{
 *  employeeBidProfile: EmployeeBidProfile.IDetailedEmployeeBidProfile;
 *  isMobile?: boolean;
 * }} param0
 */
const EmployeeInfoContent = ({
    employeeBidProfile,
    isMobile,
}) => {
    const { t } = useTranslation('shiftBidding');
    const { t: tEmployee } = useTranslation('shiftBidding', { keyPrefix: 'employee' });
    const {
        employeeRank: { rank: employeeRank },
        isSelectionAmountBasedOnRanks,
        name: bidName,
        requestPeriodEndDate,
        requestPeriodStartDate,
        isForeverRequestPeriod,
        submissionPeriodEndDate,
        submissionPeriodStartDate,
        status,
    } = employeeBidProfile;

    const eeRulesPrefix = 'admin.setupEdit.rulesStep';
    const isEnabledLabel = t(`admin.${isSelectionAmountBasedOnRanks ? 'enabled' : 'disabled'}`);

    const submissionStartLabel = tEmployee('submissionStartDate');
    const submissionEndLabel = tEmployee('submissionEndDate');
    const requestPeriodLabel = tEmployee('requestPeriod');
    const employeeRankAsOrdinal = useOrdinalSuffix(employeeRank);

    const requestStart = DateFormatService.formatDateOrEmpty(requestPeriodStartDate, UkgDateFormat.LongDate);
    const requestEnd = isForeverRequestPeriod ? tEmployee('anytime') : DateFormatService.formatDateOrEmpty(requestPeriodEndDate, UkgDateFormat.LongDate);
    const requestPeriod = `${requestStart} - ${requestEnd}`;

    const submissionStart = DateFormatService.formatDateOrEmpty(submissionPeriodStartDate, UkgDateFormat.LongDateTime);
    const submissionEnd = DateFormatService.formatDateOrEmpty(submissionPeriodEndDate, UkgDateFormat.LongDateTime);

    const fontClass = isMobile ? 'text-sm-regular' : 'text-md-medium';

    return (
        <div className="additionalInfo">
            <div className={`title ${fontClass}`}>
                <div className="title-wrapper">
                    <h4 className="headline-h-600">{tEmployee('scheduleBiddingInfo')}</h4>
                </div>
            </div>
            <div className={`content ${fontClass}`}>
                <div className="content-wrapper">
                    {
                        !!isMobile && (
                            <div className="bid-header">
                                <p className="headline-h-700 eic-bid-name">
                                    {bidName}
                                </p>
                                <div className="bid-status">
                                    <Chip
                                        label={getProfileStatusLabel(status)}
                                        variant="outlined"
                                        style={getProfileStatusColor(status)}
                                    />
                                </div>
                            </div>
                        )
                    }
                    <div className="info-items-container">
                        <div className="info-item">
                            {`${tEmployee('common.youAreRanked')}: `}
                            {employeeRankAsOrdinal}
                        </div>
                        <div className="info-item">
                            {`${t(`${eeRulesPrefix}.isEmployeeMustSubmitRequiredAmountOfBidsInput.label`)}: `}
                            {isEnabledLabel}
                        </div>
                        <div className="info-item">
                            {`${requestPeriodLabel}: `}
                            {requestPeriod}
                        </div>
                        <div className="info-item">
                            {`${submissionStartLabel}: `}
                            {submissionStart}
                        </div>
                        <div className="info-item">
                            {`${submissionEndLabel}: `}
                            {submissionEnd}
                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
};

export default EmployeeInfoContent;
